<template>
    <div class="brands-cases">

      <!--div class="brands-cases-nav">
        <div class="brands-cases-spaccer"></div>
        <div class="brands-cases-item"></div>
        <div class="brands-cases-item"></div>
        <div class="brands-cases-item"></div>
      </div-->
      <carousel :per-page="perPage"  :paginationEnabled="true" ref="carousel"  class="carousel"  @pageChange="onPageChange"   >

        <slide class="brands-cases-item" v-for="(item, index) in cases" >

          <div class="brands-cases-item-box">
            <media-type :className="'media-brand-case'" :obj="item.media" ></media-type>

            <div class="container">
              <h3>{{item.title}}</h3>
            </div>

          </div>

        </slide>

        <slide class="brands-cases-item"  v-if="!isMobile" >   </slide>

      </carousel>
    </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../../main';
import MediaType from "./MediaType";



    export default {

        name: 'brands-cases',
      components: {MediaType},
      props: ['actRoute', 'isMobile', 'cases'],
      setup() {
        const onSwiper = (swiper) => {
          console.log(swiper);
        };
        const onSlideChange = () => {
          console.log('slide change');
        };
        return {
          onSwiper,
          onSlideChange,
        };
      },
        data() {
            return {
                actScreen: 0,
              perPage: 0

            }
        },

        created() {

          if(this.isMobile){
            this.perPage =1;
          }else{
            this.perPage =3;
          }


        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);
          this.resizeMe();

          setTimeout(function () {
            this.resizeMe();
          }, 20000);

          window.addEventListener('resize', this.resizeMe);


          $('.brands-cases').on("mousewheel", function(e, delta) {
            this.scrollLeft -= (delta * 70);
            e.preventDefault();
          });
        },

      destroyed() {

        window.removeEventListener('resize', this.resizeMe);
      },

      methods: {

        resizeMe(){
         // let refW = (window.innerWidth * 0.14)  +  (window.innerWidth * 0.07);

          let maxW = $('.brand-item').width();
          let contW = $('.brand-item .container').width();

          let refSpacer =    (( maxW -  contW) / 2) + (window.innerWidth * 0.05);
          let refMarginSpacer =    0-refSpacer;

          let refBoxW = (window.innerWidth * 0.33) + 40;

          if(window.innerWidth <=800){
            refSpacer = 0;
            refBoxW = window.innerWidth;
          }

          let refBoxH = (refBoxW * 56) / 100;

          let refBoxHmain = refBoxH + 150;
          let refBoxHmain2 = refBoxH + 70;



     




         // $('.brands-cases-spaccer').width(refSpacer);
          $('.VueCarousel-wrapper').css('padding-left', refSpacer);
          $('.VueCarousel-pagination').css('margin-left', ( 0 - (refSpacer/2)));
          $('.brands-cases-item-box').height(refBoxH);
          $('.brands-cases-item').height(refBoxHmain2);
          $('.brands-cases, .brands-cases-box').height(refBoxHmain);






        },
            init() {


            },

        onPageChange(n){





          const _this = this;

          EVENTBUS.$emit('stopVideo');



        },


        nextPage(){

          if(this.actPage < this.totalPages){
            this.$refs.carousel.goToPage(this.actPage + 1);
          }

        },

        prevPage(){

          if(this.actPage > 0){
            this.$refs.carousel.goToPage(this.actPage - 1);
          }

        },
        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/BrandsCases.vue